/**
 * Native Capacitor setup for the hybrid mobile shell (status bar, splash).
 * No-op in browser builds.
 */
import { isMobileContainer } from './device';

export async function initCapacitorNative() {
  if (!isMobileContainer()) return;

  try {
    const [{ StatusBar, Style }, { SplashScreen }] = await Promise.all([
      import('@capacitor/status-bar'),
      import('@capacitor/splash-screen'),
    ]);

    const isDark =
      typeof document !== 'undefined' &&
      document.documentElement.classList.contains('dark');

    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setBackgroundColor({ color: isDark ? '#0f172a' : '#ffffff' });
    await StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light });

    await SplashScreen.hide();
  } catch (e) {
    console.warn('Capacitor native init failed', e);
  }
}

/**
 * Sync status bar colors when theme toggles in the mobile app.
 */
export async function syncCapacitorStatusBar(theme) {
  if (!isMobileContainer()) return;

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    const isDark = theme === 'dark';
    await StatusBar.setBackgroundColor({ color: isDark ? '#0f172a' : '#ffffff' });
    await StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light });
  } catch {
    // ignore
  }
}
